export default "__VITE_ASSET__ce9d3cf2__"